import React from 'react';
import clsx from 'clsx';
export const HelperText = props => {
    const { invalid = false, children, className } = props;
    return (React.createElement("p", { className: clsx('text-sm first-letter:capitalize', !invalid && 'text-basicSurface-500', invalid && 'text-danger-600', className) }, children));
};
//# sourceMappingURL=HelperText.js.map